import { render, staticRenderFns } from "./BsSpacer.vue?vue&type=template&id=22334add&scoped=true&"
import script from "./BsSpacer.vue?vue&type=script&lang=js&"
export * from "./BsSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22334add",
  null
  
)

export default component.exports